import React, { memo } from 'react'
import { NavLink } from 'react-router-dom'

// constants
import { ROUTES } from '../../constants'

// assets
import GroSalonLogo from "../../assets/logo/GROSalon.png"


function Logo(props) {
    const { className = "h-20" } = props;

    return (
        <NavLink to={ROUTES.HOME} className="mx-auto">
            <img className={className} src={GroSalonLogo} alt="GRO Track" />
        </NavLink>
    )
}

export default memo(Logo)